import { render, staticRenderFns } from "./AgentClientClaims.vue?vue&type=template&id=1a1881fc&scoped=true"
import script from "./AgentClientClaims.vue?vue&type=script&lang=js"
export * from "./AgentClientClaims.vue?vue&type=script&lang=js"
import style0 from "./AgentClientClaims.vue?vue&type=style&index=0&id=1a1881fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1881fc",
  null
  
)

export default component.exports